<template>
    <div class="alta-container">
      <h3>{{ id ? 'Editar Ubicación' : 'Nueva Ubicación' }}</h3>
      <div class="card shadow-sm p-3 mb-4 bg-white rounded">
        <!-- Mapa para seleccionar la ubicación -->
        <div class="map-container mt-4">
          <l-map
            style="height: 400px; width: 100%;" 
            :zoom="zoom" 
            :center="[ubicacion.latitud || -34.6037, ubicacion.longitud || -58.3816]"
            @click="actualizarCoordenadas"
          >
            <l-tile-layer 
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
            />
            <l-marker :lat-lng="[ubicacion.latitud || -34.6037, ubicacion.longitud || -58.3816]">
            </l-marker>
          </l-map>
        </div>
        
        
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label">País</label>
              <input v-model="ubicacion.pais" type="text" class="form-control" placeholder="Ingrese el país" readonly />
            </div>
            <div class="mb-3">
              <label class="form-label">Región/Provincia</label>
              <input v-model="ubicacion.region" type="text" class="form-control" placeholder="Ingrese la región/provincia" readonly />
            </div>
            <div class="mb-3">
              <label class="form-label">Ciudad</label>
              <input v-model="ubicacion.ciudad" type="text" class="form-control" placeholder="Ingrese la ciudad" readonly />
            </div>
          </div>
  
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label">Latitud</label>
              <input v-model="ubicacion.latitud" type="number" class="form-control" placeholder="Latitud" />
            </div>
            <div class="mb-3">
              <label class="form-label">Longitud</label>
              <input v-model="ubicacion.longitud" type="number" class="form-control" placeholder="Longitud" />
            </div>
          </div>
        </div>
  
        
  
        <div class="mt-4">
          <button class="btn btn-primary me-2" @click="guardarUbicacion">Guardar</button>
          <button class="btn btn-secondary" @click="cancelar">Cancelar</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from '@/axios';
  import { LMap, LTileLayer, LMarker } from "vue3-leaflet";
  import 'leaflet/dist/leaflet.css';
  
  export default {
    components: {
      LMap,
      LTileLayer,
      LMarker
    },
    props: {
      id: Number,
    },
    data() {
      return {
        ubicacion: {
          pais: '',
          region: '',
          ciudad: '',
          latitud: null,
          longitud: null,
        },
        zoom: 13,
        clubActual: this.$store.getters.getClubActual,
      };
    },
    methods: {
      actualizarCoordenadas(event) {
        this.ubicacion.latitud = event.latlng.lat;
        this.ubicacion.longitud = event.latlng.lng;
        this.geocodificarUbicacion(this.ubicacion.latitud, this.ubicacion.longitud);
      },
      async geocodificarUbicacion(latitud, longitud) {
        try {
          const response = await axios.get(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitud}&lon=${longitud}`);
          if (response.data && response.data.address) {
            const { country, state, city } = response.data.address;
            this.ubicacion.pais = country || '';
            this.ubicacion.region = state || '';
            this.ubicacion.ciudad = city || '';
          }
        } catch (error) {
          console.error('Error al realizar la geocodificación inversa:', error);
        }
      },
      async cargarUbicacion() {
        if (this.id) {
          const response = await axios.get(`/api/ubicaciones/${this.id}`, {
            params: {
              club_id: this.clubActual.id,
            },
          });
          this.ubicacion = response.data;
        }
      },
      async guardarUbicacion() {
        try {
          if (this.id) {
            await axios.put(`/api/ubicaciones/${this.id}`, {form: this.ubicacion, club_id: this.clubActual.id});
          } else {
            await axios.post('/api/ubicaciones', {form: this.ubicacion, club_id: this.clubActual.id});
          }
          this.$router.push({ name: 'GestionUbicaciones' });
        } catch (error) {
          console.error('Error al guardar la ubicación:', error);
        }
      },
      cancelar() {
        this.$router.push({ name: 'GestionUbicaciones' });
      },
    },
    mounted() {
      if (this.id) {
        this.cargarUbicacion();
      }
    },
  };
  </script>
  
  <style scoped>
  .alta-container {
    max-width: 900px;
    margin: 0 auto;
  }
  
  .map-container {
    width: 100%;
    height: 300px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .card {
    padding: 2rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
  
  h3 {
    font-weight: bold;
    margin-bottom: 20px;
  }
  
  .form-label {
    font-weight: bold;
  }
  </style>
  